import React, { useState } from "react";
import { createPortal } from "react-dom";
import useDialogo from "../UI/Modal/useDialogo";
import "../../styles/hc-modal.css";

/* ============================================================================
   PickerModal — elegir entre pocas opciones antes de abrir el formulario.

   Sustituye a las dos listas sin estilo que había en la hoja de consulta
   («Emitir certificado» y «+ Nueva orden»). Tarjetas con icono, título y una
   línea de descripción; nada de <li> pelados.
   ========================================================================== */

function Chevron() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}

/* Marca de elegido. Con solo el fondo teñido no se distinguía del hover, que
   era la queja: ahora la tarjeta elegida lleva un círculo relleno con un
   visto, y es la única que lo lleva. */
function Marca({ elegido }) {
  return (
    <span className={"hcpick__marca " + (elegido ? "hcpick__marca--on" : "")} aria-hidden="true">
      {elegido && (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 12.5l5.5 5.5L20 7" />
        </svg>
      )}
    </span>
  );
}

export default function PickerModal({
  isOpen,
  title,
  subtitle,
  options, // [{ key, titulo, descripcion, icono }]
  onSelect,
  onClose,
  continuarLabel = "Continuar",
}) {
  const [elegido, setElegido] = useState(null);
  const { cajaRef, intentarCerrar } = useDialogo({ abierto: isOpen, onCerrar: onClose });

  if (!isOpen) return null;

  const confirmar = (key) => {
    const k = key ?? elegido;
    if (!k) return;
    onSelect(k);
  };

  const contenido = (
    <div
      className="hcm__overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) intentarCerrar();
      }}
    >
      <div className="hcm hcm--sm" role="dialog" aria-modal="true" aria-label={title} ref={cajaRef} tabIndex={-1}>
        <div className="hcm__head">
          <div className="hcm__head-txt">
            <h2 className="hcm__title">{title}</h2>
            {subtitle && <div className="hcm__subtitle">{subtitle}</div>}
          </div>
          <button type="button" className="hcm__close" aria-label="Cerrar" onClick={intentarCerrar}>
            ✕
          </button>
        </div>

        <div className="hcm__body">
          <div className="hcpick" style={{ paddingTop: 12 }} role="radiogroup" aria-label={title}>
            {options.map((o) => {
              const esteElegido = elegido === o.key;
              return (
                <button
                  key={o.key}
                  type="button"
                  role="radio"
                  aria-checked={esteElegido}
                  className={"hcpick__card " + (esteElegido ? "hcpick__card--on" : "")}
                  onClick={() => setElegido(o.key)}
                  onDoubleClick={() => confirmar(o.key)}
                >
                  <Marca elegido={esteElegido} />
                  {o.icono && <span className="hcpick__icon">{o.icono}</span>}
                  <span className="hcpick__txt">
                    <span className="hcpick__t">{o.titulo}</span>
                    {o.descripcion && <span className="hcpick__d">{o.descripcion}</span>}
                  </span>
                  <span className="hcpick__chev">
                    <Chevron />
                  </span>
                </button>
              );
            })}
            {options.length === 0 && <div className="hclist__vacio">No hay opciones configuradas.</div>}
          </div>
        </div>

        <div className="hcm__foot">
          <div className="hcm__foot-grow" />
          <button type="button" className="hcbtn" onClick={intentarCerrar}>
            Cancelar
          </button>
          <button type="button" className="hcbtn hcbtn--primario" onClick={() => confirmar()} disabled={!elegido}>
            {continuarLabel}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(contenido, document.body);
}
